// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

::ng-deep .mat-mdc-dialog-container,
::ng-deep .mat-dialog-container {
  border-radius: 22px !important;
  overflow: hidden !important;
  padding: 0 !important;
}

::ng-deep .mat-mdc-dialog-surface {
  border-radius: 22px !important;
  overflow: hidden !important;
}

.reviews-list-modal {
  width: 100%;
  max-width: 800px;
  min-width: 500px;
  max-height: 90vh;
  padding: 0;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.reviews-list-modal .dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: #ffffff;
  border-bottom: 1px solid #e4e8f0;
  flex-shrink: 0;
}
.reviews-list-modal .dialog-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #333;
  line-height: 1.3;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.reviews-list-modal .dialog-header .close-button {
  color: #666;
  margin-left: 12px;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .reviews-list-modal {
    min-width: 0;
    max-width: 100vw;
    border-radius: 16px;
  }
  .reviews-list-modal .dialog-header {
    padding: 16px 16px 12px;
  }
  .reviews-list-modal .dialog-header h2 {
    font-size: 18px;
  }
  .reviews-list-modal .dialog-content {
    padding: 16px;
  }
}
.reviews-list-modal .dialog-content {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}
.reviews-list-modal .dialog-content .flow-info {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e8f0;
}
.reviews-list-modal .dialog-content .flow-info h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.reviews-list-modal .dialog-content .flow-info .reviews-count {
  margin: 0;
  color: #666;
  font-size: 14px;
}
.reviews-list-modal .dialog-content .loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 16px;
}
.reviews-list-modal .dialog-content .loading-section p {
  margin: 0;
  color: #666;
  font-size: 14px;
}
.reviews-list-modal .dialog-content .reviews-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.reviews-list-modal .dialog-content .reviews-list .review-item {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 16px;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .reviewer-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .reviewer-info .reviewer-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .reviewer-info .reviewer-avatar-placeholder {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .reviewer-info .reviewer-avatar-placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .reviewer-info .reviewer-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .reviewer-info .reviewer-details .reviewer-name {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .reviewer-info .reviewer-details .review-date {
  font-size: 12px;
  color: #666;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .review-rating {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .review-rating .star-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #ddd;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .review-rating .star-icon.filled {
  color: #ffc107;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-header .review-rating .star-icon.half {
  color: #ffc107;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-status {
  margin-bottom: 12px;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-status .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-status .status-badge mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-status .status-badge.completed {
  background: #e8f5e9;
  color: #2e7d32;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-status .status-badge.completed mat-icon {
  color: #2e7d32;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-status .status-badge.failed {
  background: #ffebee;
  color: #c62828;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-status .status-badge.failed mat-icon {
  color: #c62828;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-text {
  margin-bottom: 12px;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-text p {
  margin: 0;
  color: #333;
  font-size: 14px;
  line-height: 1.6;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-media {
  margin-bottom: 12px;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-media .media-preview {
  position: relative;
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  overflow: hidden;
  background: #f0f0f0;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-media .media-preview img {
  width: 100%;
  height: auto;
  display: block;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-media .media-preview .media-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-media .media-preview .media-overlay mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: white;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-issues {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-issues h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-issues .issue-item {
  margin-bottom: 12px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;
  border-left: 3px solid #ff9800;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-issues .issue-item .issue-header {
  margin-bottom: 8px;
  font-size: 13px;
  color: #333;
}
.reviews-list-modal .dialog-content .reviews-list .review-item .review-issues .issue-item .issue-description {
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}
.reviews-list-modal .dialog-content .no-reviews {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
  color: #999;
}
.reviews-list-modal .dialog-content .no-reviews mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #ccc;
}
.reviews-list-modal .dialog-content .no-reviews p {
  margin: 0;
  font-size: 16px;
}

@media (max-width: 640px) {
  .reviews-list-modal {
    width: 100%;
    max-width: 100%;
    min-width: auto;
    border-radius: 16px;
    max-height: 95vh;
  }
  .reviews-list-modal .dialog-header {
    padding: 16px;
  }
  .reviews-list-modal .dialog-header h2 {
    font-size: 20px;
  }
  .reviews-list-modal .dialog-content {
    padding: 16px;
  }
  .reviews-list-modal .dialog-content .reviews-list {
    gap: 16px;
  }
  .reviews-list-modal .dialog-content .reviews-list .review-item {
    padding: 16px;
  }
  .reviews-list-modal .dialog-content .reviews-list .review-item .review-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .reviews-list-modal .dialog-content .reviews-list .review-item .review-header .review-rating {
    align-self: flex-start;
  }
}
:host-context(body.theme-dark) {
  /* Keep golden star color in dark mode */
}
:host-context(body.theme-dark) .reviews-list-modal,
:host-context(body.theme-dark) .reviews-list-modal .dialog-header,
:host-context(body.theme-dark) .reviews-list-modal .dialog-content {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .reviews-list-modal h2,
:host-context(body.theme-dark) .reviews-list-modal h3,
:host-context(body.theme-dark) .reviews-list-modal h4,
:host-context(body.theme-dark) .reviews-list-modal p,
:host-context(body.theme-dark) .reviews-list-modal .reviews-count,
:host-context(body.theme-dark) .reviews-list-modal .reviewer-name,
:host-context(body.theme-dark) .reviews-list-modal .review-date,
:host-context(body.theme-dark) .reviews-list-modal .review-text p,
:host-context(body.theme-dark) .reviews-list-modal .issue-description,
:host-context(body.theme-dark) .reviews-list-modal .close-button {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .reviews-list-modal .review-item,
:host-context(body.theme-dark) .reviews-list-modal .issue-item,
:host-context(body.theme-dark) .reviews-list-modal .media-preview {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .reviews-list-modal .review-rating .star-icon.filled,
:host-context(body.theme-dark) .reviews-list-modal .review-rating .star-icon.half {
  color: #ffc107 !important;
}
:host-context(body.theme-dark) .reviews-list-modal .review-rating .star-icon:not(.filled):not(.half) {
  color: #4b5563 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/flow-reviews-list-modal/flow-reviews-list-modal.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;AAAF;;AAGA;;EAEE,8BAAA;EACA,2BAAA;EACA,qBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,2BAAA;AAAF;;AAGA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAAF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;AAAJ;AAEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAAN;AAGI;EACE,WAAA;EACA,iBAAA;EACA,cAAA;AADN;AAKE;EA5CF;IA6CI,YAAA;IACA,gBAAA;IACA,mBAAA;EAFF;EAIE;IACE,uBAAA;EAFJ;EAII;IACE,eAAA;EAFN;EAME;IACE,aAAA;EAJJ;AACF;AAOE;EACE,aAAA;EACA,gBAAA;EACA,OAAA;AALJ;AAOI;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AALN;AAOM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AALR;AAQM;EACE,SAAA;EACA,WAAA;EACA,eAAA;AANR;AAUI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;AARN;AAUM;EACE,SAAA;EACA,WAAA;EACA,eAAA;AARR;AAYI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAVN;AAYM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAVR;AAYQ;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAVV;AAYU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;AAVZ;AAYY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAVd;AAaY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAXd;AAac;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAXhB;AAeY;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAbd;AAec;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAbhB;AAgBc;EACE,eAAA;EACA,WAAA;AAdhB;AAmBU;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAjBZ;AAmBY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAjBd;AAmBc;EACE,cAAA;AAjBhB;AAoBc;EACE,cAAA;AAlBhB;AAwBQ;EACE,mBAAA;AAtBV;AAwBU;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAtBZ;AAwBY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtBd;AAyBY;EACE,mBAAA;EACA,cAAA;AAvBd;AAyBc;EACE,cAAA;AAvBhB;AA2BY;EACE,mBAAA;EACA,cAAA;AAzBd;AA2Bc;EACE,cAAA;AAzBhB;AA+BQ;EACE,mBAAA;AA7BV;AA+BU;EACE,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA7BZ;AAiCQ;EACE,mBAAA;AA/BV;AAiCU;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA/BZ;AAiCY;EACE,WAAA;EACA,YAAA;EACA,cAAA;AA/Bd;AAkCY;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;AAhCd;AAkCc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAhChB;AAsCQ;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AApCV;AAsCU;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AApCZ;AAuCU;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;AArCZ;AAuCY;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AArCd;AAwCY;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAtCd;AA6CI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AA3CN;AA6CM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA3CR;AA8CM;EACE,SAAA;EACA,eAAA;AA5CR;;AAmDA;EACE;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;EAhDF;EAkDE;IACE,aAAA;EAhDJ;EAkDI;IACE,eAAA;EAhDN;EAoDE;IACE,aAAA;EAlDJ;EAoDI;IACE,SAAA;EAlDN;EAoDM;IACE,aAAA;EAlDR;EAoDQ;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAlDV;EAoDU;IACE,sBAAA;EAlDZ;AACF;AA0DA;EA6BE,wCAAA;AApFF;AAwDE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAtDJ;AAyDE;;;;;;;;;;EAUE,yBAAA;AAvDJ;AA0DE;;;EAGE,8BAAA;EACA,iDAAA;AAxDJ;AA4DE;;EAEE,yBAAA;AA1DJ;AA6DE;EACE,yBAAA;AA3DJ","sourcesContent":["// Style the Material Dialog container to have rounded corners\n:host {\n  display: block;\n}\n\n::ng-deep .mat-mdc-dialog-container,\n::ng-deep .mat-dialog-container {\n  border-radius: 22px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n}\n\n::ng-deep .mat-mdc-dialog-surface {\n  border-radius: 22px !important;\n  overflow: hidden !important;\n}\n\n.reviews-list-modal {\n  width: 100%;\n  max-width: 800px;\n  min-width: 500px;\n  max-height: 90vh;\n  padding: 0;\n  box-sizing: border-box;\n  background: #ffffff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  .dialog-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px;\n    background: #ffffff;\n    border-bottom: 1px solid #e4e8f0;\n    flex-shrink: 0;\n\n    h2 {\n      margin: 0;\n      font-size: 22px;\n      font-weight: 600;\n      color: #333;\n      line-height: 1.3;\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n    }\n\n    .close-button {\n      color: #666;\n      margin-left: 12px;\n      flex-shrink: 0;\n    }\n  }\n\n  @media (max-width: 768px) {\n    min-width: 0;\n    max-width: 100vw;\n    border-radius: 16px;\n\n    .dialog-header {\n      padding: 16px 16px 12px;\n\n      h2 {\n        font-size: 18px;\n      }\n    }\n\n    .dialog-content {\n      padding: 16px;\n    }\n  }\n\n  .dialog-content {\n    padding: 24px;\n    overflow-y: auto;\n    flex: 1;\n\n    .flow-info {\n      margin-bottom: 24px;\n      padding-bottom: 16px;\n      border-bottom: 1px solid #e4e8f0;\n\n      h3 {\n        margin: 0 0 8px 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: #333;\n      }\n\n      .reviews-count {\n        margin: 0;\n        color: #666;\n        font-size: 14px;\n      }\n    }\n\n    .loading-section {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 40px 20px;\n      gap: 16px;\n\n      p {\n        margin: 0;\n        color: #666;\n        font-size: 14px;\n      }\n    }\n\n    .reviews-list {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n\n      .review-item {\n        padding: 20px;\n        background: #f9f9f9;\n        border-radius: 12px;\n        border: 1px solid #e0e0e0;\n\n        .review-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: flex-start;\n          margin-bottom: 12px;\n          gap: 16px;\n\n          .reviewer-info {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            flex: 1;\n\n            .reviewer-avatar {\n              width: 48px;\n              height: 48px;\n              border-radius: 50%;\n              object-fit: cover;\n            }\n\n            .reviewer-avatar-placeholder {\n              width: 48px;\n              height: 48px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              color: #999;\n\n              mat-icon {\n                font-size: 48px;\n                width: 48px;\n                height: 48px;\n              }\n            }\n\n            .reviewer-details {\n              display: flex;\n              flex-direction: column;\n              gap: 4px;\n\n              .reviewer-name {\n                margin: 0;\n                font-size: 16px;\n                font-weight: 600;\n                color: #333;\n              }\n\n              .review-date {\n                font-size: 12px;\n                color: #666;\n              }\n            }\n          }\n\n          .review-rating {\n            display: flex;\n            gap: 2px;\n            flex-shrink: 0;\n\n            .star-icon {\n              font-size: 20px;\n              width: 20px;\n              height: 20px;\n              color: #ddd;\n\n              &.filled {\n                color: #ffc107;\n              }\n\n              &.half {\n                color: #ffc107;\n              }\n            }\n          }\n        }\n\n        .review-status {\n          margin-bottom: 12px;\n\n          .status-badge {\n            display: inline-flex;\n            align-items: center;\n            gap: 6px;\n            padding: 6px 12px;\n            border-radius: 16px;\n            font-size: 13px;\n            font-weight: 500;\n\n            mat-icon {\n              font-size: 18px;\n              width: 18px;\n              height: 18px;\n            }\n\n            &.completed {\n              background: #e8f5e9;\n              color: #2e7d32;\n\n              mat-icon {\n                color: #2e7d32;\n              }\n            }\n\n            &.failed {\n              background: #ffebee;\n              color: #c62828;\n\n              mat-icon {\n                color: #c62828;\n              }\n            }\n          }\n        }\n\n        .review-text {\n          margin-bottom: 12px;\n\n          p {\n            margin: 0;\n            color: #333;\n            font-size: 14px;\n            line-height: 1.6;\n          }\n        }\n\n        .review-media {\n          margin-bottom: 12px;\n\n          .media-preview {\n            position: relative;\n            width: 100%;\n            max-width: 300px;\n            border-radius: 8px;\n            overflow: hidden;\n            background: #f0f0f0;\n\n            img {\n              width: 100%;\n              height: auto;\n              display: block;\n            }\n\n            .media-overlay {\n              position: absolute;\n              top: 0;\n              left: 0;\n              right: 0;\n              bottom: 0;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              background: rgba(0, 0, 0, 0.3);\n              cursor: pointer;\n\n              mat-icon {\n                font-size: 48px;\n                width: 48px;\n                height: 48px;\n                color: white;\n              }\n            }\n          }\n        }\n\n        .review-issues {\n          margin-top: 16px;\n          padding-top: 16px;\n          border-top: 1px solid #e0e0e0;\n\n          h4 {\n            margin: 0 0 12px 0;\n            font-size: 14px;\n            font-weight: 600;\n            color: #333;\n          }\n\n          .issue-item {\n            margin-bottom: 12px;\n            padding: 12px;\n            background: #fff;\n            border-radius: 8px;\n            border-left: 3px solid #ff9800;\n\n            .issue-header {\n              margin-bottom: 8px;\n              font-size: 13px;\n              color: #333;\n            }\n\n            .issue-description {\n              margin: 0;\n              font-size: 13px;\n              color: #666;\n              line-height: 1.5;\n            }\n          }\n        }\n      }\n    }\n\n    .no-reviews {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 60px 20px;\n      gap: 16px;\n      color: #999;\n\n      mat-icon {\n        font-size: 64px;\n        width: 64px;\n        height: 64px;\n        color: #ccc;\n      }\n\n      p {\n        margin: 0;\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n// Mobile responsiveness\n@media (max-width: 640px) {\n  .reviews-list-modal {\n    width: 100%;\n    max-width: 100%;\n    min-width: auto;\n    border-radius: 16px;\n    max-height: 95vh;\n\n    .dialog-header {\n      padding: 16px;\n\n      h2 {\n        font-size: 20px;\n      }\n    }\n\n    .dialog-content {\n      padding: 16px;\n\n      .reviews-list {\n        gap: 16px;\n\n        .review-item {\n          padding: 16px;\n\n          .review-header {\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 12px;\n\n            .review-rating {\n              align-self: flex-start;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .reviews-list-modal,\n  .reviews-list-modal .dialog-header,\n  .reviews-list-modal .dialog-content {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .reviews-list-modal h2,\n  .reviews-list-modal h3,\n  .reviews-list-modal h4,\n  .reviews-list-modal p,\n  .reviews-list-modal .reviews-count,\n  .reviews-list-modal .reviewer-name,\n  .reviews-list-modal .review-date,\n  .reviews-list-modal .review-text p,\n  .reviews-list-modal .issue-description,\n  .reviews-list-modal .close-button {\n    color: #e2e8f0 !important;\n  }\n\n  .reviews-list-modal .review-item,\n  .reviews-list-modal .issue-item,\n  .reviews-list-modal .media-preview {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  /* Keep golden star color in dark mode */\n  .reviews-list-modal .review-rating .star-icon.filled,\n  .reviews-list-modal .review-rating .star-icon.half {\n    color: #ffc107 !important;\n  }\n\n  .reviews-list-modal .review-rating .star-icon:not(.filled):not(.half) {\n    color: #4b5563 !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
